import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VAutocomplete, {
    attrs: {
      "search-input": _vm.search,
      "label": _vm.label ? _vm.label : _vm.$i18n_t('accMgmt.user.roles'),
      "items": _vm.comboRoles,
      "disabled": _vm.readonly,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "loading": _vm.isLoading,
      "autocomplete": "off",
      "item-text": "name",
      "item-value": "id",
      "hide-no-data": "",
      "multiple": "",
      "chips": "",
      "return-object": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event;
      },
      "update:search-input": function ($event) {
        _vm.search = $event;
      },
      "change": _vm.process
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_c(VChip, _vm._b({
          attrs: {
            "input-value": data.selected,
            "close": ""
          },
          on: {
            "click": data.select,
            "click:close": function ($event) {
              return _vm.remove(data.item);
            }
          }
        }, 'v-chip', data.attrs, false), [data.item.properties && data.item.properties.icon ? _c(VAvatar, {
          attrs: {
            "left": ""
          }
        }, [_c(VIcon, [_vm._v("\n          fas\n          " + _vm._s(data.item.properties.icon.startsWith('fa-') ? data.item.properties.icon : 'fa-' + data.item.properties.icon) + "\n        ")])], 1) : _vm._e(), _vm._v("\n      " + _vm._s(data.item.name) + "\n    ")], 1)];
      }
    }, {
      key: "item",
      fn: function (data) {
        return [data.item.properties && data.item.properties.icon ? _c(VListItemAvatar, [_c(VIcon, [_vm._v("\n        fas\n        " + _vm._s(data.item.properties.icon.startsWith('fa-') ? data.item.properties.icon : 'fa-' + data.item.properties.icon) + "\n      ")])], 1) : _vm._e(), _c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        })], 1)];
      }
    }]),
    model: {
      value: _vm.selectedRoles,
      callback: function ($$v) {
        _vm.selectedRoles = $$v;
      },
      expression: "selectedRoles"
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };